module.exports = __webpack_public_path__ + "img/achiever-cert-1.537448e6.png";